<template>
    <div>
        <pageHeader :headerImg="config.headerImg" :headerTitle="config.headerTitle" :headerDesc="config.headerDesc">
        </pageHeader>
    </div>
</template>

<script>
import { config } from "../js/company";
import pageHeader from "../../common/page_header.vue";
export default {
    name: '',
    components: { pageHeader },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {},
};
</script>

<style scoped></style>
